import React from 'react'
import { Input, Select } from 'antd'

const FilterIssue = ({ handleChangeFieldSeach, hanldeChangeValueSearch, valueSearch, fieldSearch }) => {

    const _handleChangeSelect = (field) => {
        handleChangeFieldSeach(field)
    }

    const _handleChangeSearch = (e) => {
        hanldeChangeValueSearch(e.target.value)
    }

    return (
        <div className='FilterIssue'>
            <Input.Group compact className='d-flex flex-nowrap'>
                <Select
                    value={fieldSearch}
                    style={{ minWidth: '34%', fontWeight: 600 }}
                    onChange={_handleChangeSelect}
                >
                    <Select.Option value="barcode">Barcode</Select.Option>
                    <Select.Option value="package_name">Package name</Select.Option>
                    <Select.Option value="store">Store</Select.Option>
                </Select>
                <Input
                    style={{ width: '66%' }}
                    value={valueSearch}
                    placeholder='Nhập để tìm kiếm'
                    onChange={_handleChangeSearch}
                />
            </Input.Group>
        </div>
    )
}

export default FilterIssue